export class ImageUploadDto {

  ImageBase64: string;
  FileName: string;
  MimeType: string;

}
